import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import CrudPrinter from '../components/CrudPrinter';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'common.printers'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        workshopID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.workshop',
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['workshop/isLoading'],
            options: vue.$store.getters['workshop/loadedItems']
          }
        },
        printers: {
          type: CrudPrinter,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'clientCode',
            permissionCode: 'Printer'
          }
        }
      }
    ]
  };
}

const layoutGeneral = {
  named: true,
  sections: [
    {
      fields: ['name', 'workshopID']
    }
  ]
};

const layoutTabPrinters = {
  named: true,
  sections: [
    {
      fields: ['printers']
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutGeneral]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutGeneral, layoutTabPrinters]
  };
}

export function createItemFromFormData(vue, form) {
  return { ...form };
}

export function createFormDataFromItem(vue, item) {
  return { ...item };
}
